module.exports = __webpack_public_path__ + "staticfr/media/logo.bb63e3d7.svg";